import React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Box,
    Icon
} from '@mui/material';

import { useCompany } from './CompanyContext';

const TopBar = ({ user }) => {
    // Context first, fall back to passed user prop, then defaults
    const { companyLogo, companyName: ctxCompanyName, companyId } = useCompany();
    const logoSrc = companyLogo || user?.company_logo || './FieldworkerIcon.png';
    const companyName = ctxCompanyName || user?.company_name || 'FieldWorker';

    return (
        <AppBar 
            position="fixed" 
            sx={{ 
                zIndex: 2,
                backgroundColor: '#ffffff',
                boxShadow: '5px 5px 5px grey',
                height: '70px'
            }}
        >
            <Toolbar 
                sx={{ 
                    height: '70px',
                    minHeight: '70px !important',
                    padding: '0 16px'
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Icon 
                        sx={{ 
                            height: 60, 
                            width: 60, 
                            color: '#95D0EB', 
                            ml: "-16px", 
                            mt: "-5px" 
                        }}
                    >
                        <img
                            src={logoSrc}
                            alt="logo" 
                            style={{ height: 60, width: 60 }}
                            onError={(e) => {
                                console.log('Error loading logo:',logoSrc);
                                e.target.src = './FieldworkerIcon.png';
                            }}
                        />
                    </Icon>
                    <Box sx={{ display: 'flex', flexDirection: 'column', ml: '1px', mt: '5px' }}>
                        <Typography 
                            variant='h6'
                            sx={{ 
                                color: '#3FA7D6', 
                                alignSelf: "center",
                                padding: 0,
                                margin: 0,
                                lineHeight: 1
                            }}
                        >
                            {companyName}
                        </Typography>
                        <Typography 
                            variant="caption" 
                            sx={{ 
                                fontSize: '12px', 
                                padding: 0, 
                                color: '#95D0EB', 
                                alignSelf: 'center',
                                mt: 0.5 // add a little space above the tagline
                            }}
                        >
                            {companyId ? 'Powered by Fieldworker' : 'Referral Management'}
                        </Typography>
                    </Box>
                </Box>

                {/* Spacer to push content to the right if needed */}
                <Box sx={{ flexGrow: 1 }} />
                
                {/* Right side content area - empty for now as requested */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* This is where additional toolbar items would go */}
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;
